var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: _vm.src,
    staticClass: "absolute-fill"
  }, [_vm.loading || !_vm.isPreview && _vm.blob.template && !_vm.blob.user_id && _vm.isEditable && !_vm.isSelected ? _c('div', {
    staticClass: "absolute-fill template-editable"
  }) : _vm._e(), _c('picture', {
    staticClass: "user-select-none",
    attrs: {
      "draggable": "false"
    }
  }, [_vm.static && _vm.blob.img.src_static ? _c('img', {
    attrs: {
      "draggable": "false",
      "src": _vm.blob.img.src_static
    },
    on: {
      "load": _vm.end,
      "error": _vm.end,
      "abort": _vm.end
    }
  }) : [_vm.isPreview && _vm.webp && _vm.supportsWebp ? _c('source', {
    attrs: {
      "srcset": _vm.src + '.webp',
      "type": "image/webp"
    }
  }) : _vm._e(), _c('img', {
    attrs: {
      "src": _vm.src,
      "draggable": "false"
    },
    on: {
      "load": _vm.end,
      "error": _vm.end,
      "abort": _vm.end
    }
  })]], 2)]);
}
var staticRenderFns = []

export { render, staticRenderFns }